import React, { useState, useEffect } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import { withTranslation, useTranslation } from "react-i18next";

// Icons
import { HiOutlineDotsVertical } from "react-icons/hi";
import { BiLike, BiDislike, BiSolidLike, BiSolidDislike } from "react-icons/bi";
import { MdOutlineModeComment } from "react-icons/md";
import { IoIosClose } from "react-icons/io";
import { RiEditBoxFill } from "react-icons/ri";
import { 
  FaFilePdf, 
  FaFileVideo, 
  FaFileAudio, 
  FaFileImage 
} from "react-icons/fa6";

// Images
import book_1 from "../../assets/new/images/Feed/book_1.svg";
import book_2 from "../../assets/new/images/Feed/book_2.svg";
import book_3 from "../../assets/new/images/Feed/book_3.svg";
import book_4 from "../../assets/new/images/Feed/book_4.svg";
import book_5 from "../../assets/new/images/Feed/book_5.svg";
import book_6 from "../../assets/new/images/Feed/book_6.svg";
import book_7 from "../../assets/new/images/Feed/book_7.svg";
import book_8 from "../../assets/new/images/Feed/book_8.svg";
import book_9 from "../../assets/new/images/Feed/book_9.svg";
import filter_icon from "../../assets/new/images/filter_icon.svg";
import DiaryIcon from "../../assets/new/images/DiaryIcon.svg";
import Sharemodal from "../../assets/new/images/Sharemodel.svg";
import add_btn from "../../assets/new/images/Fourms/add_btn.svg";

// Components
import Footer from "../../component/Footer";
import SpinnerCmp from "../../component/SpinnerCmp";
import BreadCrumbs from "../../component/BreadCrumbs";

// Styles
import "../../assets/new/css/Forum.css";
import "../../assets/new/css/MyDiary.css";
import "../../assets/new/css/SchoolTvChannel.css";
import "../Feed/Feed.css";
import "../../assets/new/css/communication.css";
import "react-toastify/dist/ReactToastify.css";

// Static Data
const STATIC_FORUM_DATA = [
  {
    forum_id: 1,
    forum_title: "Mathematics Problem Discussion",
    forum_description: "I'm having trouble understanding quadratic equations. Can anyone explain how to solve problems like 2x² + 5x - 3 = 0?",
    forum_createdby: 101,
    forum_creator_image: "user1.jpg",
    forum_creater: "John Smith",
    forum_category: 1,
    forum_attachment: "math_notes.pdf",
    forum_like_count: 15,
    forum_dislike_count: 2,
    forum_comment_count: 8,
    forum_created_date: "2023-10-15T14:30:00",
    forum_updated_date: "2023-10-16T09:15:00",
    existing_like: false,
    existing_dislike: false,
    category_name: "Mathematics"
  },
  {
    forum_id: 2,
    forum_title: "Literature Club Meeting",
    forum_description: "Let's discuss the symbolism in 'To Kill a Mockingbird'. What did you think about the mockingbird metaphor throughout the novel?",
    forum_createdby: 102,
    forum_creator_image: "user2.jpg",
    forum_creater: "Emily Johnson",
    forum_category: 2,
    forum_attachment: "mockinbird_analysis.docx",
    forum_like_count: 23,
    forum_dislike_count: 1,
    forum_comment_count: 12,
    forum_created_date: "2023-10-12T10:45:00",
    forum_updated_date: "2023-10-14T16:20:00",
    existing_like: true,
    existing_dislike: false,
    category_name: "Literature"
  },
  {
    forum_id: 3,
    forum_title: "Science Fair Project Ideas",
    forum_description: "Looking for innovative ideas for the upcoming science fair. Any suggestions for experiments that demonstrate renewable energy concepts?",
    forum_createdby: 103,
    forum_creator_image: "user3.jpg",
    forum_creater: "Michael Chen",
    forum_category: 3,
    forum_attachment: "science_fair_ideas.pdf",
    forum_like_count: 31,
    forum_dislike_count: 3,
    forum_comment_count: 17,
    forum_created_date: "2023-10-10T08:20:00",
    forum_updated_date: "2023-10-13T11:40:00",
    existing_like: false,
    existing_dislike: true,
    category_name: "Science"
  },
  {
    forum_id: 4,
    forum_title: "History Research Paper Sources",
    forum_description: "I'm writing a paper on the causes of World War I and need help finding reliable primary sources. Any recommendations?",
    forum_createdby: 104,
    forum_creator_image: "user4.jpg",
    forum_creater: "Sarah Williams",
    forum_category: 4,
    forum_attachment: "wwi_sources.docx",
    forum_like_count: 18,
    forum_dislike_count: 2,
    forum_comment_count: 9,
    forum_created_date: "2023-10-08T13:15:00",
    forum_updated_date: "2023-10-11T14:25:00",
    existing_like: true,
    existing_dislike: false,
    category_name: "History"
  },
  {
    forum_id: 5,
    forum_title: "Programming Help Needed",
    forum_description: "Stuck on a Python problem with list comprehensions. How would you write a comprehension that returns only even numbers squared from a list?",
    forum_createdby: 105,
    forum_creator_image: "user5.jpg",
    forum_creater: "David Kim",
    forum_category: 5,
    forum_attachment: "python_code.py",
    forum_like_count: 27,
    forum_dislike_count: 4,
    forum_comment_count: 14,
    forum_created_date: "2023-10-05T16:40:00",
    forum_updated_date: "2023-10-07T10:30:00",
    existing_like: false,
    existing_dislike: false,
    category_name: "Computer Science"
  },
  {
    forum_id: 6,
    forum_title: "Art Project Collaboration",
    forum_description: "Looking for someone to collaborate on a mural project for the school hallway. Any talented artists interested?",
    forum_createdby: 101,
    forum_creator_image: "user1.jpg",
    forum_creater: "John Smith",
    forum_category: 6,
    forum_attachment: "mural_sketch.png",
    forum_like_count: 12,
    forum_dislike_count: 1,
    forum_comment_count: 6,
    forum_created_date: "2023-10-03T11:20:00",
    forum_updated_date: "2023-10-04T15:45:00",
    existing_like: false,
    existing_dislike: false,
    category_name: "Art"
  },
  // Additional forum items
  ...Array.from({ length: 20 }, (_, i) => ({
    forum_id: i + 7,
    forum_title: `Forum Discussion ${i + 7}`,
    forum_description: `This is a sample forum description for discussion topic ${i + 7}. It contains detailed information about the subject matter.`,
    forum_createdby: i % 2 === 0 ? 101 : 102,
    forum_creator_image: i % 2 === 0 ? "user1.jpg" : "user2.jpg",
    forum_creater: i % 2 === 0 ? "John Smith" : "Emily Johnson",
    forum_category: (i % 6) + 1,
    forum_attachment: i % 4 === 0 ? `document_${i}.pdf` : i % 4 === 1 ? `image_${i}.jpg` : i % 4 === 2 ? `video_${i}.mp4` : "",
    forum_like_count: Math.floor(Math.random() * 50),
    forum_dislike_count: Math.floor(Math.random() * 10),
    forum_comment_count: Math.floor(Math.random() * 30),
    forum_created_date: new Date(Date.now() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000).toISOString(),
    forum_updated_date: new Date(Date.now() - Math.floor(Math.random() * 15) * 24 * 60 * 60 * 1000).toISOString(),
    existing_like: i % 3 === 0,
    existing_dislike: i % 5 === 0,
    category_name: ["Mathematics", "Literature", "Science", "History", "Computer Science", "Art"][i % 6]
  }))
];

const STATIC_CATEGORY_DATA = [
  { category_id: 1, category_name: "Mathematics" },
  { category_id: 2, category_name: "Literature" },
  { category_id: 3, category_name: "Science" },
  { category_id: 4, category_name: "History" },
  { category_id: 5, category_name: "Computer Science" },
  { category_id: 6, category_name: "Art" },
  { category_id: 7, category_name: "Music" },
  { category_id: 8, category_name: "Physical Education" }
];

const STATIC_USER_ID = 101; // Current user ID

function Fourms() {
  const [show, setShow] = useState(false);
  const [modalShowEdit, setModalShowEdit] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [q, setQ] = useState("");
  const [searchParam] = useState(["title"]);
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [forumLists, setForumLists] = useState([]);
  const [total, setTotal] = useState(10);
  const [page, setPage] = useState(1);
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [status, setStatus] = useState("");
  const [pageControle, setPageControle] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [title, setTitle] = useState("");
  const [validated, setValidated] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [description, setDescription] = useState("");
  const [categoryLists, setCategoryLists] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [forumId, setForumId] = useState("");
  const [isShownItem, setIsShownItem] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isAttached, setIsAttached] = useState("");
  const { t, i18n } = useTranslation();
  const [totalPage, setTotalPage] = useState(STATIC_FORUM_DATA.length);
  
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();

  // Initialize with static data
  useEffect(() => {
    setForumLists(STATIC_FORUM_DATA.slice(0, 6));
    setCategoryLists(STATIC_CATEGORY_DATA);
  }, []);

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      createForum();
      setModalShow(false);
      setModalShowEdit(false);
    }

    setValidated(true);
  };

  const handleIconClick = (index) => {
    setDropdownOpen(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // Simulate pagination
  const endreached = async () => {
    if (pageControle === false && forumLists.length < STATIC_FORUM_DATA.length) {
      setPageControle(true);
      setTimeout(() => {
        const nextPageData = STATIC_FORUM_DATA.slice(
          forumLists.length, 
          forumLists.length + 3
        );
        setForumLists(prev => [...prev, ...nextPageData]);
        setPage(page + 1);
        setPageControle(false);
      }, 1000);
    }
  };

  const handleChangeRadio = (option) => {
    setSelectedRadio(option);
    let filteredData = [...STATIC_FORUM_DATA];
    
    switch(option) {
      case "f-option": // Most Liked
        filteredData.sort((a, b) => b.forum_like_count - a.forum_like_count);
        setStatus("Most Liked");
        break;
      case "s-option": // Most Unliked
        filteredData.sort((a, b) => b.forum_dislike_count - a.forum_dislike_count);
        setStatus("Most UnLiked");
        break;
      case "t-option": // Most Commented
        filteredData.sort((a, b) => b.forum_comment_count - a.forum_comment_count);
        setStatus("Most Comment");
        break;
      case "d-option": // My Forum
        filteredData = filteredData.filter(item => item.forum_createdby === STATIC_USER_ID);
        setStatus("My Forum");
        break;
      default:
        break;
    }
    
    setForumLists(filteredData.slice(0, 6));
    setPage(1);
  };

  const handleToggle = (index) => {
    if (expanded === index) {
      setExpanded(null);
      setIsExpanded(false);
    } else {
      setExpanded(index);
      setIsExpanded(true);
    }
  };

  const handleClear = () => {
    setTitle("");
    setDescription("");
    setCategoryId("");
  };

  // Create or edit forum (simulated)
  const createForum = async () => {
    if (title && description && categoryId) {
      if (section === "create") {
        const newForum = {
          forum_id: Math.max(...STATIC_FORUM_DATA.map(f => f.forum_id)) + 1,
          forum_title: title,
          forum_description: description,
          forum_createdby: STATIC_USER_ID,
          forum_creator_image: "user1.jpg",
          forum_creater: "Current User",
          forum_category: parseInt(categoryId),
          forum_attachment: selectedFiles.length > 0 ? selectedFiles[0].name : "",
          forum_like_count: 0,
          forum_dislike_count: 0,
          forum_comment_count: 0,
          forum_created_date: new Date().toISOString(),
          forum_updated_date: new Date().toISOString(),
          existing_like: false,
          existing_dislike: false,
          category_name: categoryLists.find(c => c.category_id === parseInt(categoryId))?.category_name || ""
        };
        
        // Add to beginning of list
        setForumLists(prev => [newForum, ...prev]);
        toast.success("Forum created successfully!");
      } else if (section === "edit") {
        // Update existing forum
        setForumLists(prev => 
          prev.map(item => 
            item.forum_id === forumId 
              ? {
                  ...item,
                  forum_title: title,
                  forum_description: description,
                  forum_category: parseInt(categoryId),
                  forum_attachment: selectedFiles.length > 0 ? selectedFiles[0].name : isAttached,
                  forum_updated_date: new Date().toISOString(),
                  category_name: categoryLists.find(c => c.category_id === parseInt(categoryId))?.category_name || ""
                }
              : item
          )
        );
        toast.success("Forum updated successfully!");
      }
      
      // Reset form
      setTitle("");
      setDescription("");
      setCategoryId("");
      setSelectedFiles([]);
      setIsAttached("");
    }
  };

  const handleCategory = (cateid) => {
    setCategoryId(cateid);
  };

  const handleFileChange = (e) => {
    setSelectedFiles([...Array.from(e.target.files)]);
  };

  const handleDelete = (index) => {
    const newFiles = [...selectedFiles];
    newFiles.splice(index, 1);
    setSelectedFiles(newFiles);
  };

  const handleDelete1 = () => {
    setIsAttached("");
  };

  // Fixed Like/Dislike functionality
  const likeEvent = (id) => {
    setForumLists(prev => 
      prev.map(item => {
        if (item.forum_id === id) {
          // If already liked, remove the like
          if (item.existing_like) {
            return {
              ...item,
              forum_like_count: item.forum_like_count - 1,
              existing_like: false
            };
          } 
          // If not liked, add like and remove dislike if exists
          else {
            return {
              ...item,
              forum_like_count: item.forum_like_count + 1,
              forum_dislike_count: item.existing_dislike ? item.forum_dislike_count - 1 : item.forum_dislike_count,
              existing_like: true,
              existing_dislike: false
            };
          }
        }
        return item;
      })
    );
  };

  const dislikeEvent = (id) => {
    setForumLists(prev => 
      prev.map(item => {
        if (item.forum_id === id) {
          // If already disliked, remove the dislike
          if (item.existing_dislike) {
            return {
              ...item,
              forum_dislike_count: item.forum_dislike_count - 1,
              existing_dislike: false
            };
          } 
          // If not disliked, add dislike and remove like if exists
          else {
            return {
              ...item,
              forum_dislike_count: item.forum_dislike_count + 1,
              forum_like_count: item.existing_like ? item.forum_like_count - 1 : item.forum_like_count,
              existing_dislike: true,
              existing_like: false
            };
          }
        }
        return item;
      })
    );
  };

  const handleCopy = (forum_id) => {
    const currentUrl = window.location.href;
    const trimmedUrl = currentUrl.replace(
      "/Forum",
      `/Forum/ForumView?id=${forum_id}`
    );
    
    navigator.clipboard.writeText(trimmedUrl)
      .then(() => {
        setIsCopied(true);
        toast.success("URL copied!");
        setTimeout(() => setIsCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  // Search functionality
  function search(books) {
    return books.filter((items) => {
      return searchParam.some((newItem) => {
        return (
          items[newItem].toString().toLowerCase().indexOf(q.toLowerCase()) > -1
        );
      });
    });
  }

  const totals = totalPage - forumLists.length;
  const [section, setSection] = useState("");

  return (
    <div>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper sidebar-icon">
          <div className="page-body" id="container">
            <BreadCrumbs />
            <div className="Forum library">
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="books-main-wrapper">
                      <div className="col-md-12">
                        <div style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}>
                          <h3 className="headstyle" style={{ flex: 1 }}>
                            {t("Forums")}
                          </h3>
                          <div className="top-btn-wrapper">
                            <button onClick={() => {
                              setModalShow(true);
                              setSection("create");
                            }}>
                              <img src={add_btn} alt="" />
                              {t("Create Forum")}
                            </button>
                          </div>
                          <img
                            src={filter_icon}
                            alt=""
                            onClick={handleShow}
                          />
                        </div>
                      </div>
                      
                      <div className="my-books">
                        {q === "" ? "" : <p className="search-result">Search Results</p>}
                        <InfiniteScroll
                          style={{ overflow: "hidden" }}
                          dataLength={forumLists.length}
                          next={endreached}
                          hasMore={forumLists.length < STATIC_FORUM_DATA.length}
                          loader={<SpinnerCmp loading={true} />}
                        >
                          <div className="row">
                            {forumLists.map((item, index) => (
                              <div className="col-md-6 col-lg-4 col-sm-12" key={item.forum_id}>
                                <div className="cardFeed live-course123">
                                  <div className="d-flex">
                                    {!item.forum_attachment ? (
                                      <img className="flex-grow-0" src={DiaryIcon} alt="Diary" />
                                    ) : item.forum_attachment.split(".").pop() === "pdf" ? (
                                      <div className="flex-grow-0">
                                        <FaFilePdf
                                          style={{
                                            width: "60px",
                                            height: "70px",
                                            color: "#758522",
                                            marginTop: "6px",
                                            marginLeft: "7px",
                                          }}
                                        />
                                      </div>
                                    ) : item.forum_attachment.split(".").pop() === "jpg" || 
                                      item.forum_attachment.split(".").pop() === "webp" || 
                                      item.forum_attachment.split(".").pop() === "png" ? (
                                      <div className="flex-grow-0">
                                        <FaFileImage
                                          style={{
                                            width: "60px",
                                            height: "60px",
                                            color: "#758522",
                                            marginTop: "10px",
                                          }}
                                        />
                                      </div>
                                    ) : item.forum_attachment.split(".").pop() === "mp4" ? (
                                      <div className="flex-grow-0">
                                        <FaFileVideo
                                          style={{
                                            width: "65px",
                                            height: "60px",
                                            color: "#758522",
                                            marginTop: "10px",
                                          }}
                                        />
                                      </div>
                                    ) : item.forum_attachment.split(".").pop() === "mp3" ? (
                                      <div className="flex-grow-0">
                                        <FaFileAudio
                                          style={{
                                            width: "60px",
                                            height: "60px",
                                            color: "#758522",
                                            marginTop: "10px",
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <img className="flex-grow-0" src={DiaryIcon} alt="Diary" />
                                    )}
                                    
                                    <Link
                                      className="flex-grow-1"
                                      to={`/Forum/ForumView?id=${encodeURIComponent(item.forum_id)}`}
                                    >
                                      <div className="flex-grow-1">
                                        <p className="route-titles">
                                          {isExpanded && expanded === index
                                            ? item.forum_title.charAt(0).toUpperCase() + 
                                              item.forum_title.slice(1).substring(0, 2000)
                                            : item.forum_title.charAt(0).toUpperCase() + 
                                              item.forum_title.slice(1).substring(0, 15)}
                                          &nbsp;&nbsp;
                                          {item.forum_title.length > 10 ? (
                                            <span
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleToggle(index);
                                              }}
                                              style={{ fontSize: "12px", color: "gray", cursor: "pointer" }}
                                            >
                                              {isExpanded && expanded === index
                                                ? t("Read less")
                                                : t("Read more")}
                                            </span>
                                          ) : null}
                                        </p>
                                        <div className="d-flex ml-2" style={{ gap: "10px" }}>
                                          <div style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "20px",
                                            backgroundColor: "#ddd",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                          }}>
                                            {item.forum_creater.charAt(0)}
                                          </div>
                                          <p style={{ color: "#5f6166" }}>{item.forum_creater}</p>
                                        </div>
                                      </div>
                                    </Link>
                                    
                                    <div className="app">
                                      <div className="icon" onClick={() => handleIconClick(index)}>
                                        <HiOutlineDotsVertical className="coloricon" />
                                      </div>

                                      <div className={`dropdown-modal ${dropdownOpen[index] ? "open" : ""}`}>
                                        <div>
                                          {item.forum_createdby === STATIC_USER_ID ? (
                                            <div
                                              className="mod"
                                              onClick={() => {
                                                setModalShowEdit(true);
                                                setForumId(item.forum_id);
                                                setIsShownItem(item);
                                                setTitle(item.forum_title);
                                                setDescription(item.forum_description);
                                                setIsAttached(item.forum_attachment);
                                                setCategoryId(item.forum_category.toString());
                                                setSection("edit");
                                              }}
                                              style={{ cursor: "pointer" }}
                                            >
                                              <RiEditBoxFill
                                                style={{
                                                  width: "20px",
                                                  height: "30px",
                                                  color: "#5E6B1E",
                                                }}
                                              />
                                              <p className="modtxt">{t("Edit")}</p>
                                            </div>
                                          ) : null}
                                          <div
                                            className="mod"
                                            onClick={() => handleCopy(item.forum_id)}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <img src={Sharemodal} alt="Share" />
                                            <p className="modtxt">{t("Share")}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="d-flex align-items-center mt-2">
                                    <div className="d-flex align-items-center ml-1">
                                      <div
                                        className="like-btn align-items-center"
                                        onClick={() => likeEvent(item.forum_id)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {item.existing_like ? (
                                          <BiSolidLike
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              color: "#ADC927",
                                            }}
                                          />
                                        ) : (
                                          <BiLike
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              color: "#758522",
                                            }}
                                          />
                                        )}
                                        <span className="margin-left">{item.forum_like_count}</span>
                                      </div>
                                      <div
                                        className="dislike-btn align-items-center margin-left"
                                        onClick={() => dislikeEvent(item.forum_id)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {item.existing_dislike ? (
                                          <BiSolidDislike
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              color: "#ADC927",
                                            }}
                                          />
                                        ) : (
                                          <BiDislike
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              color: "#758522",
                                            }}
                                          />
                                        )}
                                        <span className="margin-left">{item.forum_dislike_count}</span>
                                      </div>
                                      <div className="comments-btn align-items-center margin-left">
                                        <Link
                                          to={{
                                            pathname: `/Forum/ForumView`,
                                            search: `?id=${encodeURIComponent(item.forum_id)}`,
                                            state: { scrollToBottom: true },
                                          }}
                                        >
                                          <MdOutlineModeComment
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              color: "#758522",
                                            }}
                                          />
                                        </Link>
                                        <span className="margin-left">{item.forum_comment_count}</span>
                                      </div>
                                    </div>
                                    <div className="flex-grow-1">
                                      <div style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}>
                                        <span className="margin-left" style={{ color: "#758522" }}>
                                          {moment(item.forum_created_date).format("YYYY-MM-DD")}
                                          {"    "}
                                          {moment(item.forum_updated_date, "HH:mm").format("hh:mm ")}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                          <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <label className="remain-label">
                              {t("Total Remaining Forums")} {totals}
                            </label>
                          </div>
                        </InfiniteScroll>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <ToastContainer style={{ marginTop: "50px" }} />
            </div>

            {/* Filter Modal */}
            <Modal
              show={show}
              onHide={handleClose}
              size="sm"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              className="common-filter-modal"
            >
              <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                  <div className="title-wrapper">
                    <p>{t("Filter By")}</p>
                    <p onClick={() => {
                      handleClose();
                      setForumLists(STATIC_FORUM_DATA.slice(0, 6));
                      setSelectedRadio(null);
                    }}>
                      {t("Clear")}
                    </p>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="select-wrapper">
                  <ul>
                    <li>
                      <input
                        type="radio"
                        id="f-option"
                        name="selector"
                        checked={selectedRadio === "f-option"}
                        onChange={() => handleChangeRadio("f-option")}
                      />
                      <label htmlFor="f-option">{t("Most Liked")}</label>
                      <div className="check"></div>
                    </li>

                    <li>
                      <input
                        type="radio"
                        id="s-option"
                        name="selector"
                        checked={selectedRadio === "s-option"}
                        onChange={() => handleChangeRadio("s-option")}
                      />
                      <label htmlFor="s-option">{t("Most UnLiked")}</label>
                      <div className="check"><div className="inside"></div></div>
                    </li>

                    <li>
                      <input
                        type="radio"
                        id="t-option"
                        name="selector"
                        checked={selectedRadio === "t-option"}
                        onChange={() => handleChangeRadio("t-option")}
                      />
                      <label htmlFor="t-option">{t("Most Commented")}</label>
                      <div className="check"><div className="inside"></div></div>
                    </li>
                    <li>
                      <input
                        type="radio"
                        id="d-option"
                        name="selector"
                        checked={selectedRadio === "d-option"}
                        onChange={() => handleChangeRadio("d-option")}
                      />
                      <label htmlFor="d-option">{t("My Forum")}</label>
                      <div className="check"><div className="inside"></div></div>
                    </li>
                  </ul>
                </div>
              </Modal.Body>
            </Modal>

            {/* Create Forum Modal */}
            <Modal
              show={modalShow}
              onHide={() => {
                setModalShow(false);
                handleClear();
              }}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Form noValidate validated={validated} onSubmit={handleSubmit} id="myForm">
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter" className="route-title">
                    {t("Create Forum")}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="modal-form-wrapper">
                    <div className="row">
                      <div className="col-md-12 route-title">
                        <Form.Group className="mb-3" controlId="validationCustomTitle">
                          <Form.Label className="route-title">
                            {t("Title")}
                            <span style={{ marginBottom: "20px" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={t("Type Your Title Here...")}
                            required
                            onChange={(e) => setTitle(e.target.value)}
                            value={title}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("Please provide a title")}.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="col-md-12 route-title">
                        <Form.Group className="mb-3" controlId="validationCustomCategory">
                          <Form.Label className="route-title">
                            {t("Category")}
                            <span style={{ marginBottom: "20px" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            onChange={(e) => handleCategory(e.target.value)}
                            required
                            defaultValue=""
                          >
                            <option value="">{t("Select")}</option>
                            {categoryLists.map((categories) => (
                              <option key={categories.category_id} value={categories.category_id}>
                                {categories.category_name}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {t("Please choose a category")}.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>

                      <div className="col-md-12 route-title">
                        <Form.Group className="mb-3" controlId="validationCustomForumText" style={{ height: "100%" }}>
                          <Form.Label className="route-title">
                            {t("Forum Text")}
                            <span style={{ marginBottom: "20px" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            placeholder={t("Type Your Text Here...")}
                            required
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("Please provide forum text")}.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>

                      <div className="col-md-12 route-title">
                        <Form.Group className="mb-3" controlId="validationCustomAttachments">
                          <Form.Label>{t("Attachments")}</Form.Label>
                          <Form.Control type="file" multiple onChange={handleFileChange} />
                          {selectedFiles.map((file, index) => (
                            <div key={index} style={{ display: "flex", justifyContent: "space-between" }}>
                              <p>{file.name}</p>
                              <div onClick={() => handleDelete(index)} style={{ cursor: "pointer" }}>
                                <IoIosClose />
                              </div>
                            </div>
                          ))}
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="btn-wrapper border-top w-100">
                    <button
                      onClick={() => {
                        setModalShow(false);
                        handleClear();
                      }}
                      className="cx-btn-1"
                    >
                      {t("Cancel")}
                    </button>
                    <button
                      type="submit"
                      className="cx-btn-2"
                      onClick={() => setSection("create")}
                    >
                      {t("Publish")}
                    </button>
                  </div>
                </Modal.Footer>
              </Form>
            </Modal>

            {/* Edit Forum Modal */}
            <Modal
              show={modalShowEdit}
              onHide={() => {
                setModalShowEdit(false);
                handleClear();
                setIsShownItem(null);
              }}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Form noValidate validated={validated} onSubmit={handleSubmit} id="myForm">
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter" className="route-title">
                    {t("Edit Forum")}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="modal-form-wrapper">
                    <div className="row">
                      <div className="col-md-12 route-title">
                        <Form.Group className="mb-3" controlId="validationCustomTitle">
                          <Form.Label className="route-title">
                            {t("Title")}
                            <span style={{ marginBottom: "20px" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={t("Type Your Title Here...")}
                            required
                            onChange={(e) => setTitle(e.target.value)}
                            value={title}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("Please provide a title")}.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="col-md-12 route-title">
                        <Form.Group className="mb-3" controlId="validationCustomCategory">
                          <Form.Label className="route-title">
                            {t("Category")}
                            <span style={{ marginBottom: "20px" }}>*</span>
                          </Form.Label>
                          <Form.Select
                            onChange={(e) => handleCategory(e.target.value)}
                            required
                            value={categoryId}
                          >
                            <option value={isShownItem?.forum_category}>
                              {isShownItem?.category_name}
                            </option>
                            {categoryLists.map((categories) => (
                              <option key={categories.category_id} value={categories.category_id}>
                                {categories.category_name}
                              </option>
                            ))}
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {t("Please choose a category")}.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>

                      <div className="col-md-12 route-title">
                        <Form.Group className="mb-3" controlId="validationCustomForumText" style={{ height: "100%" }}>
                          <Form.Label className="route-title">
                            {t("Forum Text")}
                            <span style={{ marginBottom: "20px" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            placeholder={t("Type Your Text Here...")}
                            required
                            onChange={(e) => setDescription(e.target.value)}
                            value={description}
                          />
                          <Form.Control.Feedback type="invalid">
                            {t("Please provide forum text")}.
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>

                      <div className="col-md-12 route-title">
                        <Form.Group className="mb-3" controlId="validationCustomAttachments">
                          <Form.Label>{t("Attachments")}</Form.Label>
                          <Form.Control type="file" multiple onChange={handleFileChange} />
                          {isAttached ? (
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                              <p>{isAttached}</p>
                              <div onClick={handleDelete1} style={{ cursor: "pointer" }}>
                                <IoIosClose />
                              </div>
                            </div>
                          ) : (
                            selectedFiles.map((file, index) => (
                              <div key={index} style={{ display: "flex", justifyContent: "space-between" }}>
                                <p>{file.name}</p>
                                <div onClick={() => handleDelete(index)} style={{ cursor: "pointer" }}>
                                  <IoIosClose />
                                </div>
                              </div>
                            ))
                          )}
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="btn-wrapper border-top w-100">
                    <button
                      onClick={() => {
                        setModalShowEdit(false);
                        handleClear();
                        setIsShownItem(null);
                      }}
                      className="cx-btn-1"
                    >
                      {t("Cancel")}
                    </button>
                    <button
                      type="submit"
                      className="cx-btn-2"
                      onClick={() => setSection("edit")}
                    >
                      {t("Update")}
                    </button>
                  </div>
                </Modal.Footer>
              </Form>
            </Modal>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(Fourms);